import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import CollectionsBootstrap from '../lib/CollectionsBootstrap'
import { OneOnOnesContextProvider } from '../lib/context/OneOnOnesContextProvider'
import { useOneOnOnesContext } from '../lib/hooks/useOneOnOnesContext'

const OneOnOnesRootPageWrapper = () => {
  const { canSeeOneOnOnes, loading } = useOneOnOnesContext()

  if (loading) {
    return null
  }

  return (
    <AuthorizeUser authorizeFn={() => canSeeOneOnOnes}>
      <Outlet
        context={{
          loading: false,
        }}
      />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <OneOnOnesContextProvider>
        <OneOnOnesRootPageWrapper />
      </OneOnOnesContextProvider>
    </CollectionsBootstrap>
  )
}

export default RootPage
